import { ApiResponseError } from '../api/rest';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getOrganizationMembers } from '../api';
import { useAccountContext } from '../context/AccountContext';
import {
  OrganizationMember,
  OrganizationMemberStatuses,
} from '../types/Account';
import { useBoolean } from './useBoolean';

export const useEnterpriseAccountMembers = () => {
  const { organization } = useAccountContext();
  const [error, setError] = useState<Error | ApiResponseError>();
  const [loading, toggleLoading] = useBoolean(true);
  const [members, setMembers] = useState<OrganizationMember[]>([]);

  const orgId = organization!.orgId;

  const fetch = useCallback(
    () => getOrganizationMembers(orgId).then(setMembers).catch(setError),
    [orgId],
  );

  useEffect(() => {
    if (organization) {
      fetch().finally(toggleLoading);
    }
  }, [organization, toggleLoading, fetch]);

  const usedSeats = useMemo(() => getUsedSeatsCount(members), [members]);

  return { loading, members, refetch: fetch, error, usedSeats };
};

/**
 * count the # of used seats from a list of members
 */
const getUsedSeatsCount = (members: OrganizationMember[]) => {
  return members.reduce(
    (count, m) =>
      m.orgStatus === OrganizationMemberStatuses.Active ||
      m.orgStatus === OrganizationMemberStatuses.Invited
        ? count + 1
        : count,
    0,
  );
};
